<script>
import { memberPetOptions, getCategoryOption, getSizeOption } from "@utils/ipetbooking-options";
import { merchantComputed } from '@store/helpers'
import formatDate from '@utils/format-date'

export default {
  components: {
    FormReservationPrepaidJtails: () => import("@components/Form/FormReservationPrepaid.Jtails"),
    ListPrepaidOrder: () => import("@components/List/ListPrepaidOrder.Jtails"),
    ReservationSectionTitlePrepaid: () => import("@components/Reservation/ReservationSectionTitlePrepaid"),
  },
  props: {
    value: {
      type: Object,
      default: () => {
        return {}
      },
    },
    prepaidOrderList: {
      type: Array,
      default: () => {
        return []
      },
    },
    prepaidOrderPagination: {
      type: Object,
      default: () => {
        return {
          "current_page": 1,
          "first_page_url": "http://admin.ds.test/api/merchant/prepaids?page=1",
          "from": 1,
          "last_page": 1,
          "last_page_url": "http://admin.ds.test/api/merchant/prepaids?page=1",
          "next_page_url": null,
          "path": "http://admin.ds.test/api/merchant/prepaids",
          "per_page": 6,
          "prev_page_url": null,
          "to": 3,
          "total": 50
        }
      }
    },
    tempSubmitData: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {
      activePrepaid: 0,
    }
  },
  computed: {
    ...merchantComputed,
    memberPetOptions,
    submitData: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value);
      }
    },
    categoryTitle() {
      return getCategoryOption({
        value: this.tempSubmitData.category,
        key: 'title'
      });
    },
    sizeTitle() {
      return getSizeOption({
        value: this.tempSubmitData.sizeAlias,
        category: this.tempSubmitData.category,
        key: 'title'
      });
    },
  },
  methods: {
    formatDate,
    onInit(params) {
      this.$emit('init', params);
    },
    onChangePagination(page) {
      this.onSubmitCallback({
        page
      });

      this.activePrepaid = 0
    },
    onSubmitCallback(params) {
      this.$emit('submitCallback', {
        ...params,
        ...this.submitData
      });
    },
  }
}
</script>
<!-- section template -->
<template>
  <section
    :class="[$style.sectionReaervationJtails, { [$style.isStyleDingBeauty]: $globalIsDingBeauty }]"
    class="section"
  >
    <div class="container">
      <div class="row sectionReaervationJtails__head">
        <div class="col-lg-4">
          <span class="sectionReaervationJtails__title">我的{{ $t('site.USER') }}</span>
        </div>
        <div class="col-lg-8">
          <ReservationSectionTitlePrepaid
            class="d-none d-lg-block"
            :category="tempSubmitData.category"
            :size-alias="tempSubmitData.sizeAlias"
          />
        </div>
      </div>
    </div>
    <div class="container">
      <div class="row">
        <div class="col-lg-4">
          <div class="sectionReaervationJtails__formBox">
            <BaseSticky
              :offset="0"
              :menu-height="80"
              :space-top="40"
              :space-bottom="40"
            >

              <div class="sectionReaervationJtails__form">
                <FormReservationPrepaidJtails
                  v-model="submitData"
                  :temp-submit-data="tempSubmitData"
                  @submitCallback="onSubmitCallback"
                  @init="onInit"
                />
              </div>
            </BaseSticky>
          </div>
        </div>
        <div
          v-loading="$isLoading('fetchApplicablePrepaidOrderList')"
          :element-loading-text="`正在取得可用的${$t('site.PREPAID')}`"
          class="col-lg-8"
        >
          <div id="reservation-list" style="position: relative; top: -10rem"></div>
          <BaseNull
            v-if="!$isLoading('fetchApplicablePrepaidOrderList') && prepaidOrderList.length === 0"
            :image="`${ require(`@assets/images/${$globalProjectName}/reservation/no-service.svg`) }`"
            :title="`目前無此${$t('site.USER')}可使用的包月方案，立即購買可用的${currentMerchant.prepaidSetting.title || $t('site.PREPAID_TITLE')}`"
          >
            <BaseButton
              v-if="currentMerchant.prepaidSetting.isEnabled"
              class="isStylePrimary mt-5"
              :class="{
                'isRadius isOutline3 isCol4': $globalIsJtails,
                'isFull': $globalIsDingBeauty,
              }"
              :to="{ name: 'prepaid' }"
            >
              前往購買<i class="far fa-arrow-right ml-2"></i>
            </BaseButton>
          </BaseNull>
          <ListPrepaidOrder
            v-else
            v-model="activePrepaid"
            :order-list="prepaidOrderList"
            :temp-submit-data="tempSubmitData"
            type="prepaid-reservation"
          />
          <BasePagination
            v-if="prepaidOrderPagination.last_page > 1"
            :pagination="prepaidOrderPagination"
            class="sectionReaervationJtails__pagination"
            @change="onChangePagination"
          />
        </div>
      </div>
    </div>
  </section>
</template>
<!-- section style -->
<style lang="scss" module>
.sectionReaervationJtails {
  :global {
    .sectionReaervationJtails {

      &__formBox {
        position: relative;
        height: 100%;

        @include max-lg {
          height: auto;
          margin-bottom: 6rem;
        }

        &::before {
          @include max-lg {
            position: absolute;
            top: -93px;
            right: -$container-gap;
            bottom: -3rem;
            left: -$container-gap;
            z-index: -1;
            content: '';
            background-color: rgba(#EFE5E0, 0.3)
            // background-image: linear-gradient(to right, rgba($color-secondary, 0.1), rgba($color-secondary, 0.1)), url('~@assets/images/layout/bg-marble.jpg');
          }
        }
      }

      &__head {
        margin-bottom: 2rem;
      }

      &__title {
        font-family: $font-serif;
        font-size: 1.125rem;
        font-weight: 600;
        color: $color-primary-dark;
        letter-spacing: 0.2em;
      }

      &__prepaidText {
        font-family: $font-serif;
        font-size: 1.125rem;
        font-weight: 600;
        color: $color-primary-dark;
        letter-spacing: 0.2em;
      }

      &__pagination {
        padding-top: 2rem;
      }
    }
  }
  &.isStyleDingBeauty {
    :global {
      .sectionReaervationJtails {
        &__formBox {
          &::before {
            @include max-lg {
              background-color: $color-bg-default
              // background-image: linear-gradient(to right, rgba($color-secondary, 0.1), rgba($color-secondary, 0.1)), url('~@assets/images/layout/bg-marble.jpg');
            }
          }
        }
        &__title {
          font-family: unset;
          font-weight: 400;
          color: $color-secondary;
        }
      }
    }
  }
}
</style>
